/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
    interface Window { fbq?: (...args: any[]) => void; }
}

const fbq = (...args: any[]) => {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq(...args);
    }
};

/** Genera un UUID v4 simple para deduplicación con CAPI */
export function genEventId(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

export const pixel = {
    /** Standard Meta events */
    pageView:              ()                                          => fbq('track', 'PageView'),
    viewContent:           ()                                          => fbq('track', 'ViewContent'),
    addToCart:             ()                                          => fbq('track', 'AddToCart'),

    /** Acepta eventId para deduplicar con CAPI server-side */
    lead:                  (eventId?: string)                          => fbq('track', 'Lead',                 eventId ? { eventID: eventId } : {}),
    completeRegistration:  (eventId?: string)                          => fbq('track', 'CompleteRegistration', eventId ? { eventID: `${eventId}_reg` } : {}),
    startTrial:            (eventId?: string)                          => fbq('track', 'StartTrial',           eventId ? { eventID: eventId } : {}),

    initiateCheckout:      (value: number)                             => fbq('track', 'InitiateCheckout', { value, currency: 'USD' }),
    purchase:              (value: number, plan: string)               => fbq('track', 'Purchase', { value, currency: 'USD', content_name: `Plan ${plan}` }),
};
